import { Component } from '@angular/core';

@Component({
  selector: 'rt-walkthrough-empty-component',
  standalone: true,

  template: '',
})
export class WalkthroughEmptyComponent {}
